/* Source content interactions, native Shopify forms remain live outside local preview. */
(() => {
  const local = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
  function init(root = document) {
    root.querySelectorAll('[data-content-accordion]').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      group.querySelectorAll('.accordion-question button').forEach(button => {
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') !== 'true';
          group.querySelectorAll('.accordion-question button').forEach(trigger => {
            const expanded = trigger === button && open;
            const panel = document.getElementById(trigger.getAttribute('aria-controls'));
            trigger.setAttribute('aria-expanded', String(expanded));
            trigger.closest('.accordion-item').dataset.expanded = String(expanded);
            panel.setAttribute('aria-hidden', String(!expanded));
            panel.inert = !expanded;
            panel.style.height = expanded ? `${panel.scrollHeight}px` : '0px';
            panel.style.opacity = expanded ? '1' : '0';
          });
        });
      });
    });
    root.querySelectorAll('.contact-form').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const topic = form.querySelector('[data-contact-topic]');
      const order = form.querySelector('[data-contact-order]');
      const status = form.querySelector('[data-contact-status]');
      topic?.addEventListener('change', () => {
        order.hidden = topic.value !== 'order';
        order.querySelector('input').disabled = order.hidden;
      });
      if (local) {
        form.querySelector('[data-contact-note]').textContent = 'You’re viewing the local storefront. This form lets you preview your enquiry; it does not send a message.';
        form.querySelector('[data-contact-submit-label]').textContent = 'Preview enquiry';
        form.addEventListener('input', () => { status.hidden = true; status.replaceChildren(); });
        form.addEventListener('submit', event => {
          event.preventDefault();
          status.hidden = false;
          const message = document.createElement('p');
          message.textContent = 'Your enquiry is ready to preview. Nothing has been sent. To contact Ainaz, use the contact form on the live Shopify store.';
          status.replaceChildren(message);
        });
      }
    });
    if (local) root.querySelectorAll('[data-content-account-link]').forEach(link => { link.href = 'https://ainazbyga.myshopify.com/account'; });
    else root.querySelectorAll('[data-content-local-note]').forEach(note => { note.hidden = true; });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  window.addEventListener('resize', () => document.querySelectorAll('[data-content-accordion] .accordion-item[data-expanded="true"] .accordion-panel').forEach(panel => { panel.style.height = `${panel.scrollHeight}px`; }));
})();
